Vue.component('product-selector', {
    template: `
    <div class='ProductSelector'>
        <div v-if='isInitialized === false'>Loading...</div>

        <div class="alert alert-danger" v-if="errors.length">
            <p class="font-weight-bold">Please correct the following error(s):</p>
            <ul class="indented">
                <li v-for="errorMessage in errorsDistinctMessages">{{ errorMessage }}</li>
            </ul>
        </div>

        <div v-if='isInitialized === true'>
            
            <div class='subGroupContainer' v-for='productGroup in productSelectionData.groups'>
                <h2>{{ productGroup.title }}</h2>
                <div class='table-responsive'>
                    <table class='table table-sm table-bordered table-striped table-hover'>
                        <thead>
                            <tr class='text-center'>
                                <th class='d-sm-none'>Product & Amount Discount Per {{ productGroup.unitOfMeasureSingle }}</th>
                                <th class='d-none d-sm-table-cell'>SKU</th>
                                <th class='d-none d-sm-table-cell'>Product</th>
                                <th>{{ productGroup.unitOfMeasurePlural }} Purchased</th>
                                <th class='d-none d-sm-table-cell'>Amount Discounted Per {{ productGroup.unitOfMeasureSingle }}</th>
                                <th>Product Rebate Earned</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for='lineItem in filterLineItemsByGroup(productGroup.id)'
                                v-bind:key='lineItem.id'
                            >
                                <td class='d-sm-none'>
                                    <b>SKU:</b> {{ lineItem.id }}<br />
                                    {{ lineItem.description }}<br />
                                    <b>Discount:</b> {{ $Apfco.formatCurrency(lineItem.value) }}<br />
                                </td>
                                <td class='d-none d-sm-table-cell'>{{ lineItem.id }}</td>
                                <td class='d-none d-sm-table-cell'>{{ lineItem.description }}</td>
                                <td class='subColQuantity'>
                                    <input v-bind:class="getClassLineItemQuantity(lineItem.id)" type='number' maxlength='10' value='' v-model='lineItem.quantity' v-on:blur="handleFormUpdate"/>
                                </td>
                                <td class='d-none d-sm-table-cell text-right' v-html="lineItem.value"></td>
                                <td class='text-right'>{{ $Apfco.formatCurrency(lineItem.extendedValue) }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class='font-weight-bold'>
                                <td colspan='2' class='d-md-none'>Total Product Rebate Earned For Group</td>
                                <td colspan='4' class='d-none d-md-table-cell'>Total Product Rebate Earned For Group</td>
                                <td class='text-right'>{{ $Apfco.formatCurrency(sumLineItemsRewardByGroup(productGroup.id)) }}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <div v-if="hasBonus">
                <h2>BONUS REBATE: Buy from multiple {{ productSelectionData.groupingDescription }} to increase rebate</h2>
                <div class='table-responsive'>
                    <table class='table table-sm table-bordered table-striped'>
                        <thead>
                            <tr class='text-center'>
                                <th colspan='2'></th>
                                <th>Combined Base Rebate Earned</th>
                                <th>Bonus Rebate %</th>
                                <th>Bonus Rebate Earned</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class='text-center'>
                                <td class='text-left'>Pick 2</td>
                                <td>Buy from TWO {{ productSelectionData.groupingDescription }} for 10% bonus</td>
                                <td>
                                    <span v-if='productSelectionData.bonusPercentage === 0.1'>
                                        {{ $Apfco.formatCurrency(productSelectionData.subtotal) }}
                                    </span>
                                </td>
                                <td>10%</td>
                                <td>
                                    <span v-if='productSelectionData.bonusPercentage === 0.1'>
                                        {{ $Apfco.formatCurrency(productSelectionData.bonusValue) }}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="hasBonus15" class='text-left font-weight-bold'>
                                <td colspan='5'>or</td>
                            </tr>
                            <tr v-if="hasBonus15" class='text-center'>
                                <td class='text-left'>Pick 3</td>
                                <td>Buy from THREE {{ productSelectionData.groupingDescription }} for a 15% bonus</td>
                                <td>
                                    <span v-if='productSelectionData.bonusPercentage === 0.15'>
                                        {{ $Apfco.formatCurrency(productSelectionData.subtotal) }}
                                    </span>
                                </td>
                                <td>15%</td>
                                <td>
                                    <span v-if='productSelectionData.bonusPercentage === 0.15'>
                                        {{ $Apfco.formatCurrency(productSelectionData.bonusValue) }}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="hasBonus20" class='text-left font-weight-bold'>
                                <td colspan='5'>or</td>
                            </tr>
                            <tr v-if="hasBonus20" class='text-center'>
                                <td class='text-left'>Pick 3</td>
                                <td>Buy from THREE {{ productSelectionData.groupingDescription }} for a 20% bonus</td>
                                <td>
                                    <span v-if='productSelectionData.bonusPercentage === 0.2'>
                                        {{ $Apfco.formatCurrency(productSelectionData.subtotal) }}
                                    </span>
                                </td>
                                <td>20%</td>
                                <td>
                                    <span v-if='productSelectionData.bonusPercentage === 0.2'>
                                        {{ $Apfco.formatCurrency(productSelectionData.bonusValue) }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div>
                <h2>Grand Total Saved</h2>
                <div class='table-responsive'>
                    <table class='table table-sm table-bordered table-striped'>
                        <thead>
                            <tr class='text-center'>
                                <th>Combined Base Rebate Earned</th>
                                <th v-if="hasBonus">Bonus Rebate Earned</th>
                                <th>Total Rebate Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class='text-center'>
                                <td>{{ $Apfco.formatCurrency(productSelectionData.subtotal) }}</td>
                                <td v-if="hasBonus">{{ $Apfco.formatCurrency(productSelectionData.bonusValue) }}</td>
                                <td>{{ $Apfco.formatCurrency(productSelectionData.totalValue) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            
        </div>
    </div>
    `,
    props: {
        promotionId: String,
        urlApiCalculateProductSelectorData: String
    },
    data: function () {
        return {
            isInitialized: false,
            productSelectionData: null,
            errors: []
        }
    },
    created: async function () {
        console.log('Component - initializing..')
        await this.initialize();
        console.log('Component - initialization complete.')
    },
    methods: {
        initialize: async function () {
            console.log('Initializing..');
            console.log('Getting product selection data..');
            await this.calculateProductSelectionData();
            this.isInitialized = true;
            console.log('Initialization complete.');
        },
        calculateProductSelectionData: async function() {
            let thisObj = this;

            //Build the request body
            let requestBody = {
                lineItems = []
            };
            if (this.productSelectionData) {
                for (var i in this.productSelectionData.lineItems) {
                    let lineItem = this.productSelectionData.lineItems[i];
                    requestBody.lineItems.push({
                        "id": lineItem.id,
                        "quantity": "" + lineItem.quantity, //Make sure it's a string value
                    });
                }
            }
            
            //Call the API endpoint as POST
            await axios.post(thisObj.$props.urlApiCalculateProductSelectorData
                , JSON.stringify(requestBody) 
                , {
                    headers: { 'Content-Type': 'application/json' }
                }
            )
            .then(function (response) {
                console.log('Success', response);
                thisObj.productSelectionData = response.data;

                //Loop through each lineitem and format
                for (let i = 0; i < thisObj.productSelectionData.lineItems.length; i++) {
                    let lineItem = thisObj.productSelectionData.lineItems[i];

                    //R12600 product 139952 requires a different display since the calculation for that item is different from other items
                    if (thisObj.$props.promotionId === "R12600" && lineItem.id == "139952")
                        lineItem.value = '$32 rebate if purchase <span class="utilDispInlineBlock">144 singles</span>';
                    else
                        lineItem.value = Apfco.formatCurrency(lineItem.value);
                }
            })
            .catch(function (error) {
                console.log('Failed', error.response);
            });
        },
        getClassLineItemQuantity: function (id) {
            let output = "form-control text-right ";

            if (this.errors.filter(x => x.id === id).length > 0) {
                output += "alert-danger";
            }
            return output;
        },
        filterLineItemsByGroup(productGroupId) {
            let output = this.productSelectionData.lineItems.filter(lineItem => lineItem.productGroupId === productGroupId); //Filter the base data set
            let customProductIdOrder = [];

            //Sort the products - either arbitrary promotion-specific ordering from the mail-in form, or the default natural sort
            if (this.$props.promotionId === "R10952") { //Use a custom order - https://stackoverflow.com/questions/50028512/sort-an-object-array-by-custom-order
                customProductIdOrder = ["139938", "139937", "139930", "139929", "139923", "139922", "137465", "137463", "137462", "138809", "138808", "138785", "138784", "126661", "126662", "126663", "118986", "118066", "139949", "139950", "138587", "138554"]
                output.sort((a, b) => customProductIdOrder.indexOf(a.id) - customProductIdOrder.indexOf(b.id));
            }
            else { //For everything else - Natural sort for alphanumeric strings - see here: https://fuzzytolerance.info/blog/2019/07/19/The-better-way-to-do-natural-sort-in-JavaScript/
                output.sort((a, b) => {
                    //Try sorting by sort order first before using the natural sort
                    if (a.sortOrder < b.sortOrder)
                        return -1;
                    if (a.sortOrder > b.sortOrder)
                        return 1;

                    return a.description.localeCompare(b.description, navigator.languages[0] || navigator.language, { numeric: true, ignorePunctuation: false, sensitivity: 'base' })
                });
            }

            return output;
        },
        sumLineItemsRewardByGroup(produtGroupId) {
            let lineItems = this.filterLineItemsByGroup(produtGroupId);
            let output = lineItems.reduce((accumulation, item) => accumulation + item.extendedValue, 0); //https://stackoverflow.com/questions/35480773/sum-values-of-objects-in-array/35480862
            return output;
        },
        handleFormUpdate: async function () {

            //Do all initial formatting
            await this.handleFormatting();

            //Validate the form field
            await this.handleValidation();

            //If there were no errors, do the calculations
            if (!this.errors.length) {
                await this.handleCalculation();
            }
        },
        handleFormatting: async function () {

            //Loop through each lineitem and format
            for (let i = 0; i < this.productSelectionData.lineItems.length; i++) {
                let lineItem = this.productSelectionData.lineItems[i];

                //If null or empty, replace with zero
                if (!lineItem.quantity) {
                    lineItem.quantity = 0;
                }
            }

        },
        handleValidation: async function () {

            //Clear any previous errors
            this.errors = [];

            //Loop through each lineitem and validate the values
            for (let i = 0; i < this.productSelectionData.lineItems.length; i++) {
                let lineItem = this.productSelectionData.lineItems[i];

                if (!Apfco.isInteger(lineItem.quantity)) {
                    this.errors.push({ id: lineItem.id, message:"All quantities must be valid integers - no non-numeric characters or decimal values are allowed."});
                }

                if (lineItem.quantity < 0 || lineItem.quantity > 9999) {
                    this.errors.push({ id: lineItem.id, message:"All quantities must be between 0 and 9999."});
                }
            }
        },
        handleCalculation: async function () {
            await this.calculateProductSelectionData();
        }
    },
    computed: {
        errorsDistinctMessages: function () { //Return a list of distinct error messages found in the errors array, for display in the top
            var output = [];
            for (i = 0; i < this.errors.length; i++) {
                if (output[this.errors[i].message]) continue;
                output[this.errors[i].message] = true;
                output.push(this.errors[i].message);
            }
            return output;
        },
        hasBonus: function () { //2022-02-15 - Some promotions do not have any bonus offers
            if (['R10955', 'R10956', 'R10957', 'R10958', 'R12142', 'R12143', 'R12254', 'R12255', 'R12430', 'R12707', 'R12802', 'R12884', 'R12936', 'R12955', 'R13288', 'R13458', 'R13459', 'R13849','R13900','R13910'].indexOf(this.$props.promotionId) >= 0) {
                return false;
            }
            return true;
        },
        hasBonus15: function () {
            if (['R12600','R12834','R13243','R13405'].indexOf(this.$props.promotionId) >= 0) {
                return true;
            }
            return false;
        },
        hasBonus20: function () { //2021-04-30 - Implemented quick solution for R10952, which has no 20% offer
            if (['R10950', 'R10951', 'R10953', 'R10954', 'R10959', 'R12180'].indexOf(this.$props.promotionId) >= 0) {
                return true;
            }
            return false;
        }
    }
    
})